export * from './Home.jsx';



/** WEBPACK FOOTER **
 ** ./docs/screens/home/index.js
 **/